<div class="loading">
    <p-progress-spinner ariaLabel="loading" />
</div>
